import React, { Component } from 'react';
import styled from 'styled-components';
import ErrorBoundary from '../../ErrorBoundary';

const Skip = styled.div`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export default class NavSkip extends Component {
  static propTypes = {};

  render() {
    return (
      <ErrorBoundary>
        <Skip className="nav-nav-skip">
          <button tabIndex="0" href="../framing/Framing">
            Skip nav
          </button>
        </Skip>
      </ErrorBoundary>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/nav/NavSkip.js